/**
 * AJAX utilities for people, investments, and posts filtering
 */

// People filtering AJAX utility
export function initPeopleAjax() {
    const functionDropdown = document.getElementById('people-filter--function');
    const titleDropdown = document.getElementById('people-filter--title');
    const locationDropdown = document.getElementById('people-filter--location');
    const peopleGrid = document.querySelector('.people--grid');

    if (!functionDropdown || !titleDropdown || !locationDropdown || !peopleGrid) {
        return;
    }

    // Get nonce from WordPress
    const nonce = window.localized_object ? window.localized_object.nonce : '';

    function filterPeople() {
        const functionValue = functionDropdown.value;
        const titleValue = titleDropdown.value;
        const locationValue = locationDropdown.value;

        // Show loading state
        peopleGrid.style.opacity = '0.5';
        peopleGrid.style.pointerEvents = 'none';

        // Prepare data for AJAX request
        const formData = new FormData();
        formData.append('action', 'get_people');
        formData.append('nonce', nonce);
        formData.append('function', functionValue);
        formData.append('title', titleValue);
        formData.append('location', locationValue);

        // Make AJAX request
        fetch(window.localized_object ? window.localized_object.ajax_url : '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Update the people grid with new content
                    peopleGrid.innerHTML = data.data.html;

                    // Update URL with filter parameters (optional)
                    updatePeopleURL(functionValue, titleValue, locationValue);

                } else {
                    console.error('AJAX Error:', data.data.message);
                    // Show error message to user
                    peopleGrid.innerHTML = '<div class="error-message">Sorry, there was an error loading the results. Please try again.</div>';
                }
            })
            .catch(error => {
                console.error('Fetch Error:', error);
                peopleGrid.innerHTML = '<div class="error-message">Sorry, there was an error loading the results. Please try again.</div>';
            })
            .finally(() => {
                // Restore normal state
                peopleGrid.style.opacity = '1';
                peopleGrid.style.pointerEvents = 'auto';
                triggerPeopleAnimations();
            });
    }

    function triggerPeopleAnimations() {
        const peopleItems = document.querySelectorAll('.people--item');
        setTimeout(() => {
            peopleItems.forEach(item => {
                item.classList.add('over');
            });
        }, 100);
    }

    function updatePeopleURL(functionValue, titleValue, locationValue) {
        const url = new URL(window.location);

        // Update or remove URL parameters
        if (functionValue && functionValue !== 'senior-leadership') {
            url.searchParams.set('function', functionValue);
        } else {
            url.searchParams.delete('function');
        }

        if (titleValue) {
            url.searchParams.set('title', titleValue);
        } else {
            url.searchParams.delete('title');
        }

        if (locationValue) {
            url.searchParams.set('location', locationValue);
        } else {
            url.searchParams.delete('location');
        }

        // Update browser URL without page reload
        window.history.pushState({}, '', url);
    }

    // Add event listeners to dropdowns
    functionDropdown.addEventListener('change', filterPeople);
    titleDropdown.addEventListener('change', filterPeople);
    locationDropdown.addEventListener('change', filterPeople);

    // Global function for reset filters link
    window.resetPeopleFilters = function () {
        // Reset dropdowns to default values
        if (functionDropdown) {
            functionDropdown.value = 'senior-leadership';
        }
        if (titleDropdown) {
            titleDropdown.value = '';
        }
        if (locationDropdown) {
            locationDropdown.value = '';
        }

        // Trigger the filter function to reload all results
        filterPeople();
    }
}

// Investments filtering AJAX utility
export function initPublicationsAjax() {
    const statusDropdown = document.getElementById('investment-filter--status');
    const subsectorDropdown = document.getElementById('investment-filter--subsector');
    const investmentTypeDropdown = document.getElementById('investment-filter--investment_type');
    const investmentsGrid = document.querySelector('.investment--grid');

    if (!statusDropdown || !subsectorDropdown || !investmentTypeDropdown || !investmentsGrid) {
        return;
    }

    // Get nonce from WordPress
    const nonce = window.localized_object ? window.localized_object.nonce : '';

    function filterInvestments() {
        const statusValue = statusDropdown.value;
        const subsectorValue = subsectorDropdown.value;
        const investmentTypeValue = investmentTypeDropdown.value;

        // Show loading state
        investmentsGrid.style.opacity = '0.5';
        investmentsGrid.style.pointerEvents = 'none';

        // Prepare data for AJAX request
        const formData = new FormData();
        formData.append('action', 'get_investments');
        formData.append('nonce', nonce);
        formData.append('status', statusValue);
        formData.append('subsector', subsectorValue);
        formData.append('investment_type', investmentTypeValue);

        // Make AJAX request
        fetch(window.localized_object ? window.localized_object.ajax_url : '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Update the investments grid with new content
                    investmentsGrid.innerHTML = data.data.html;

                    // Update URL with filter parameters (optional)
                    updateInvestmentsURL(statusValue, subsectorValue, investmentTypeValue);

                } else {
                    console.error('AJAX Error:', data.data.message);
                    // Show error message to user
                    investmentsGrid.innerHTML = '<div class="error-message">Sorry, there was an error loading the results. Please try again.</div>';
                }
            })
            .catch(error => {
                console.error('Fetch Error:', error);
                investmentsGrid.innerHTML = '<div class="error-message">Sorry, there was an error loading the results. Please try again.</div>';
            })
            .finally(() => {
                // Restore normal state
                investmentsGrid.style.opacity = '1';
                investmentsGrid.style.pointerEvents = 'auto';
                triggerInvestmentsAnimations();
            });
    }

    function triggerInvestmentsAnimations() {
        const investmentItems = document.querySelectorAll('.investment--item');
        setTimeout(() => {
            investmentItems.forEach(item => {
                item.classList.add('over');
            });
        }, 100);
    }

    function updateInvestmentsURL(statusValue, subsectorValue, investmentTypeValue) {
        const url = new URL(window.location);

        // Update or remove URL parameters
        if (statusValue && statusValue !== 'all') {
            url.searchParams.set('status', statusValue);
        } else {
            url.searchParams.delete('status');
        }

        if (subsectorValue) {
            url.searchParams.set('subsector', subsectorValue);
        } else {
            url.searchParams.delete('subsector');
        }

        if (investmentTypeValue) {
            url.searchParams.set('investment_type', investmentTypeValue);
        } else {
            url.searchParams.delete('investment_type');
        }

        // Update browser URL without page reload
        window.history.pushState({}, '', url);
    }

    // Add event listeners to dropdowns
    statusDropdown.addEventListener('change', filterInvestments);
    subsectorDropdown.addEventListener('change', filterInvestments);
    investmentTypeDropdown.addEventListener('change', filterInvestments);

    // Global function for reset filters link
    window.resetPublicationsFilters = function () {
        // Reset dropdowns to default values
        if (statusDropdown) {
            statusDropdown.value = 'all';
        }
        if (subsectorDropdown) {
            subsectorDropdown.value = '';
        }
        if (investmentTypeDropdown) {
            investmentTypeDropdown.value = '';
        }

        // Trigger the filter function to reload all results
        filterInvestments();
    }
}

// Posts filtering AJAX utility
export function initPostsAjax() {
    const postsGrid = document.querySelector('.posts--grid');
    const postsMore = document.querySelector('.posts--load--more-button');

    if (!postsGrid) {
        return;
    }

    if (postsMore) {
        postsMore.addEventListener('click', function(e) {
            e.preventDefault();
            const nextPage = parseInt(postsMore.dataset.next) || 2;
            filterPosts(nextPage);
        });
    }

    // Get nonce from WordPress
    const nonce = window.localized_object ? window.localized_object.nonce : '';

    function filterPosts(page = 1) {
        // Prevent multiple simultaneous calls
        if (postsGrid.dataset.loading === 'true') {
            return;
        }
        postsGrid.dataset.loading = 'true';

        // Show loading state
        postsGrid.style.opacity = '0.5';
        postsGrid.style.pointerEvents = 'none';

        const type = postsMore.dataset.type ? postsMore.dataset.type : 'post';

        // Prepare data for AJAX request
        const formData = new FormData();
        formData.append('action', 'get_news_posts');
        formData.append('nonce', nonce);
        formData.append('page', page);
        formData.append('type', type);
        // Make AJAX request
        fetch(window.localized_object ? window.localized_object.ajax_url : '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Append new posts to existing content
                    postsGrid.insertAdjacentHTML('beforeend', data.data.html);

                    // Update next page button or hide it if no more posts
                    if (postsMore) {
                        if (data.data.has_more) {
                            postsMore.dataset.next = data.data.next_page;
                            postsMore.style.display = 'inline-block';
                        } else {
                            // Hide the load more button if no more posts
                            postsMore.style.display = 'none';
                        }
                    }

                } else {
                    console.error('AJAX Error:', data.data ? data.data.message : 'Unknown error');
                    // Show error message to user
                    postsGrid.innerHTML = '<div class="error-message">Sorry, there was an error loading the results. Please try again.</div>';
                }
            })
            .catch(error => {
                console.error('Fetch Error:', error);
                postsGrid.innerHTML = '<div class="error-message">Sorry, there was an error loading the results. Please try again.</div>';
            })
            .finally(() => {
                // Restore normal state
                postsGrid.style.opacity = '1';
                postsGrid.style.pointerEvents = 'auto';
                postsGrid.dataset.loading = 'false';
                triggerPostsAnimations();
            });
    }

    function triggerPostsAnimations() {
        const postItems = document.querySelectorAll('.post--article');
        setTimeout(() => {
            postItems.forEach(item => {
                item.classList.add('over');
            });
        }, 100);
    }

}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initPeopleAjax();
        initPublicationsAjax();
        initPostsAjax();
    });
} else {
    initPeopleAjax();
    initPublicationsAjax();
    initPostsAjax();
}
